import { IconProp } from "@fortawesome/fontawesome-svg-core";
import classnames from "classnames";
import { capitalize, map } from "lodash-es";
import React from "react";
import ReactDOM from "react-dom";

import {
  Toast,
  ToastType,
  useActiveToasts,
  useToastDismiss,
} from "~/ui/context";

import { Icon } from "./icons";

const toastIconMap: Record<ToastType, IconProp> = {
  primary: "bell",
  secondary: "concierge-bell",
  success: "check-circle",
  danger: "exclamation-square",
  warning: "exclamation-triangle",
  info: "info-square",
};

export interface ToastDisplayProps {
  toast: Toast;
}

export const ToastDisplay: React.FC<ToastDisplayProps> = ({ toast }) => {
  const dismiss = useToastDismiss();
  const icon = toastIconMap[toast.type];
  const { id, type, message } = toast;
  const toastClasses = classnames("toast", `toast${capitalize(type)}`);
  return (
    <div className={toastClasses} onClick={() => dismiss(id)}>
      <Icon className="toastIcon" icon={icon} />
      <div className="toastContent">{message}</div>
    </div>
  );
};

export const ToastPortal: React.FC = () => {
  const toasts = useActiveToasts();
  const container = document.getElementById("toasts");
  if (container) {
    return ReactDOM.createPortal(
      <div>
        {map(toasts, (t) => (
          <ToastDisplay toast={t} key={t.id} />
        ))}
      </div>,
      container
    );
  }
  return null;
};
